export default (BSEURL) => {
  return {
    // 登陆
    login: 'http://localhost:3000/list'
  }
}



// WEBPACK FOOTER //
// ./src/api/home.js